import React from 'react'
import Editor from '../../../../../../../../components/common/Editor/Editor'
import { LANGUAGES } from '../../../../../../../../constants/languages'
import { Form } from 'antd'
import { useAssignmentAccess } from '../../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'

const TestDatabaseDump = () => {
    const { hasAccess: hasEditingPermission } = useAssignmentAccess([Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED])

    return (
        <Form.Item name='input' rules={[{ required: true, message: 'Please, enter database dump' }]}>
            <Editor
                language={LANGUAGES.SQL.value}
                title={<label>Database Dump</label>}
                readOnly={!hasEditingPermission}
            />
        </Form.Item>
    )
}

export default TestDatabaseDump
